import Editor from "./Editor";
import { useImageUploadHandler } from "./uploadImage";

const FrontEditor = props => {
  const { onChange, value, height, labelNode, attachmentToken, onFocus } = props;

  const { imagesUploadHandler } = useImageUploadHandler({ attachmentToken });

  return (
    <Editor
      labelNode={labelNode}
      value={value}
      onChange={onChange}
      height={height}
      imagesUploadHandler={imagesUploadHandler}
      plugins="autolink image link media lists wordcount"
      toolbar="blocks | bold italic | link image"
      menubar={false}
      onFocus={onFocus}
    />
  );
};

export default FrontEditor;
